export const CN_AREA_CODE = '+86'
export const CN_MOBILE_MAX_LEN = 11
export const INTL_MOBILE_MAX_LEN = 16
export const CN_MOBILE_REG = /^1[3456789]\d{9}$/

export function getMobileMaxLength(areaCode: string) {
  return areaCode === CN_AREA_CODE ? CN_MOBILE_MAX_LEN : INTL_MOBILE_MAX_LEN
}

/** 只保留数字，并按区号截到对应上限 */
export function normalizeMobileInput(value: string, areaCode: string) {
  return value.replace(/\D/g, '').slice(0, getMobileMaxLength(areaCode))
}

export function getMobileValidateStatus(mobile: string, areaCode: string): 'success' | 'error' | '' {
  if (areaCode === CN_AREA_CODE) {
    if (mobile.length !== CN_MOBILE_MAX_LEN) return ''
    return CN_MOBILE_REG.test(mobile) ? 'success' : 'error'
  }
  if (mobile.length >= 7 && mobile.length <= INTL_MOBILE_MAX_LEN) return 'success'
  return ''
}

export function isMobileValid(mobile: string, areaCode: string) {
  return getMobileValidateStatus(mobile, areaCode) === 'success'
}
